"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    componentName = componentName || 'ANONYMOUS';

    if (props[propName] == null) {
      var locationName = _react.ReactPropTypeLocationNames[location];

      if (isRequired) {
        return new Error("Required " + locationName + "`" + propName + "` was not specified in `" + componentName + "`.");
      }

      return null;
    }

    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
};

var _default = createChainableTypeChecker;
exports.default = _default;
module.exports = exports.default;